import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ICartItem {
  itemImage: string;
  itemPrice: string;
  itemName: string;
  artistName: string;
  itemSize?: string;
}

interface IArtItemState {
  items: ICartItem[];
}

const initialState: IArtItemState = { items: [] };

const ArtItemSlice = createSlice({
  name: "ArtItem",
  initialState,
  reducers: {
    addItem(state, action: PayloadAction<ICartItem>) {
      state.items.push(action.payload);
    },
    removeItem(state, action: PayloadAction<number>) {
      state.items = state.items.filter((_, index) => index !== action.payload);
    },
    clearCart(state) {
      state.items = [];
    }
  }
});

export const { addItem, removeItem, clearCart } = ArtItemSlice.actions;
export default ArtItemSlice.reducer;